import { from } from 'rxjs'
import { switchMap } from 'rxjs/operators'
import { openDB, IDBPDatabase } from 'idb'
import { IdbDbName, IdbDefaultStoreName } from '@lg/shared/for-apps'

export class IdbService {
	private db!: IDBPDatabase

	async openDb() {
		if (!this.db)
			this.db = await openDB(IdbDbName, 1, {
				upgrade(db, _oldVersion, _newVersion, _tx) {
					db.createObjectStore(IdbDefaultStoreName)
				},
			})
		return this.db
	}

	async put(key: IDBValidKey, value: any) {
		const db = await this.openDb()
		return db.put(IdbDefaultStoreName, value, key)
	}

	async get<T = any>(key: IDBValidKey) {
		const db = await this.openDb()
		try {
			const value: T = await db.get(IdbDefaultStoreName, key)
			return value
		} catch (err: any) {
			console.error(err)
		}
		return undefined
	}

	get$<T = any>(key: IDBValidKey) {
		return from(this.openDb()).pipe(
			switchMap((db) => from(db.get(IdbDefaultStoreName, key) as Promise<T>)),
		)
	}

	async delete(key: IDBValidKey) {
		const db = await this.openDb()
		await db.delete(IdbDefaultStoreName, key)
	}
}
